import { useEffect, useMemo } from 'react';

import { debounce, DebouncedFunc } from 'lodash';

function useDebounce<T>(
  setValue: (value?: T) => void,
  delay: number,
): DebouncedFunc<(val?: T) => void> {
  const debouncedSetValue = useMemo(
    () =>
      debounce(
        (val?: T) => {
          setValue(val);
        },
        delay,
        { trailing: true },
      ),
    [setValue, delay],
  );

  useEffect(() => {
    return () => {
      debouncedSetValue.flush();
    };
  }, [debouncedSetValue]);
  return debouncedSetValue;
}

export default useDebounce;
